import { currencySymbol } from './valueFormat';
/**
 * Formatting and export for financial statements: whole pounds with
 * negatives in brackets (the accounts convention), percentages to one
 * decimal place, and flattening a statement into rows for CSV / Excel.
 */
const money = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 0, minimumFractionDigits: 0 });

export function formatAmount(value, format = 'currency') {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  const n = Number(value);
  if (format === 'percent') {
    const pct = (Math.abs(n) * 100).toLocaleString('en-GB', { maximumFractionDigits: 1, minimumFractionDigits: 1 });
    return n < 0 ? `(${pct}%)` : `${pct}%`;
  }
  const rounded = Math.round(n);
  if (rounded === 0) return '–';
  const text = money.format(Math.abs(rounded));
  const withSymbol = format === 'currency' ? `${currencySymbol()}${text}` : text;
  return rounded < 0 ? `(${withSymbol})` : withSymbol;
}

/**
 * Favourable / adverse for a variance cell. Rows that should be higher
 * (revenue, profit) are favourable when the variance is positive; cost rows
 * the other way round.
 */
export function varianceTone(value, direction) {
  if (value === null || value === undefined || value === 0 || !direction) return null;
  const good = direction === 'lower' ? value < 0 : value > 0;
  return good ? 'favourable' : 'adverse';
}

/** Statement rows as plain objects for CSV / Excel (drill-down lines indented). */
export function statementToRows(result, { includeDetail = true } = {}) {
  if (!result) return [];
  const out = [];
  const line = (label, values) => {
    const row = { Line: label };
    for (const c of result.columns) {
      const v = values[c.key];
      row[c.rangeLabel ? `${c.title} (${c.rangeLabel})` : c.title] = v === null || v === undefined ? '' : v;
    }
    return row;
  };
  for (const r of result.rows) {
    out.push(line(r.label, r.values || {}));
    if (includeDetail) for (const child of r.children || []) out.push(line(`    ${child.label}`, child.values || {}));
  }
  return out;
}
